export class Feedback {
	contactId: string;
	message: string;

	constructor(contactId: string = '', message: string = '') {
		this.contactId = contactId;
		this.message = message;
	}
}